import { IIconProps } from "../types"

export default function IconUL2(props: IIconProps) {
  const width = props.size || props.width || (83 / 5) * 3
  const height = props.size || props.height || (115 / 5) * 3
  return (
    <svg
      {...props}
      width={width}
      height={height}
      className={props.className}
      style={props.style}
      viewBox="0 0 83 115"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M39.0935 0.533852C36.5143 0.743785 33.8052 1.3336 31.356 2.69316C28.8968 4.04273 26.6975 6.16205 24.6681 8.87118C22.6388 11.5703 20.7794 14.8693 17.2705 25.8357C13.7516 36.7922 8.5933 55.4063 5.58426 67.3324C2.58523 79.2686 1.7355 84.5169 1.14569 88.9155C0.555876 93.3141 0.215985 96.873 0.63585 99.912C1.06571 102.961 2.24533 105.5 3.93479 107.49C5.63425 109.479 7.83354 110.918 11.2125 111.888C14.6014 112.858 19.1699 113.368 26.4476 113.578C33.7252 113.788 43.712 113.708 51.0297 113.068C58.3473 112.438 63.0059 111.248 66.8046 109.769C70.6134 108.289 73.5825 106.51 75.6918 104.401C77.8111 102.281 79.0807 99.832 79.9704 97.7127C80.8601 95.6034 81.36 93.8239 81.6099 91.5347C81.8698 89.2554 81.8698 86.4563 80.3903 78.2489C78.9108 70.0416 75.9517 56.4259 72.7727 45.0796C69.6037 33.7432 66.2148 24.6861 63.0858 18.2582C59.9568 11.8302 57.0778 8.02145 54.3686 5.52225C51.6595 3.02305 49.1203 1.84343 46.6311 1.16365C44.1319 0.493865 41.6827 0.323919 39.0935 0.533852Z"
        fill="#E6E6E6"
        stroke="black"
        strokeWidth="0.899712"
        strokeMiterlimit="2.61313"
      />
    </svg>
  )
}
